"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardCard = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var Card_1 = __importDefault(require("@material-ui/core/Card"));
var CardContent_1 = __importDefault(require("@material-ui/core/CardContent"));
var Divider_1 = __importDefault(require("@material-ui/core/Divider"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var kinsideTokens_1 = require("../kinsideTokens");
var useStyles = styles_1.makeStyles(function (theme) { return ({
    box: {
        color: "white",
        fontSize: "36px",
        marginRight: theme.spacing(2),
    },
    "box-small": {
        color: theme.palette.secondary.main,
        marginRight: theme.spacing(2),
    },
    button: {
        position: "absolute",
        left: theme.spacing(3),
        bottom: theme.spacing(4),
    },
    card: {
        position: "relative",
        height: "444px",
        overflow: "auto",
        border: 0,
    },
    mainDivider: {
        height: 2,
        backgroundColor: kinsideTokens_1.kinsideTokens["--viridian-50"],
    },
    subDivider: {
        backgroundColor: kinsideTokens_1.kinsideTokens["--viridian-50"],
    },
    title: {
        marginBottom: theme.spacing(1),
        fontSize: 16,
        color: "white",
        "text-transform": "uppercase",
    },
    subtitle: {
        marginBottom: theme.spacing(2),
        color: "white",
        fontSize: 24,
        fontWeight: 500,
    },
    text: {
        fontSize: 16,
        fontWeight: 500,
        color: "white",
    },
    clickable: {
        cursor: "pointer",
    },
}); });
var DashboardCard = function (props) {
    var _a;
    var classes = useStyles(props);
    var renderLine = function (line, idx) {
        return (react_1.default.createElement("div", { key: "text-" + line.text },
            react_1.default.createElement("div", { style: { display: "flex", alignItems: "center", marginTop: "16px", marginBottom: "16px" }, className: props.onClickLine ? classes.clickable : undefined, onClick: props.onClickLine ? function () { return props.onClickLine(idx); } : undefined },
                (line.icon === "clock") ? react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faClock, className: line.small ? classes["box-small"] : classes.box })
                    : (line.icon === "people") ? react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faPeople, className: line.small ? classes["box-small"] : classes.box })
                        : (line.icon === "calendar") ? react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faCalendar, className: line.small ? classes["box-small"] : classes.box })
                            : (line.icon === "checkbox") ? react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faSquare, className: line.small ? classes["box-small"] : classes.box }) : null,
                react_1.default.createElement(Typography_1.default, { className: classes.text }, line.text)),
            (idx < props.lines.length - 1) && react_1.default.createElement(Divider_1.default, { variant: "fullWidth", className: classes.subDivider })));
    };
    if (!((_a = props.lines) === null || _a === void 0 ? void 0 : _a.length)) {
        return null;
    }
    return (react_1.default.createElement(Grid_1.default, { item: true, xs: true, elevation: 0, component: Card_1.default, className: classes.card, style: { backgroundColor: props.color } },
        react_1.default.createElement(CardContent_1.default, { style: { padding: 24 } },
            react_1.default.createElement(Typography_1.default, { className: classes.title }, props.title),
            react_1.default.createElement(Typography_1.default, { variant: "h2", className: classes.subtitle }, props.subtitle),
            react_1.default.createElement(Divider_1.default, { variant: "fullWidth", className: classes.mainDivider }),
            props.lines.map(function (l, idx) {
                return renderLine(l, idx);
            }),
            !!props.buttonText && react_1.default.createElement(Button_1.default, { className: classes.button, variant: "contained", color: "secondary", onClick: props.onClick }, props.buttonText))));
};
exports.DashboardCard = DashboardCard;
